import React from "react";
import "./Input.css";

interface InputProps {
  type: string;
  label?: string;
  placeholder?: string;
  value: string;
  name?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  search?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  required?: boolean;
  onClickEndIcon?: () => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  autoComplete?: string;
  lang?: string;
}

const Input: React.FC<InputProps> = ({
  type,
  label,
  placeholder,
  value,
  name,
  onChange,
  search = false,
  startIcon,
  endIcon,
  required = false,
  onClickEndIcon,
  onFocus,
  onClick,
  onKeyPress,
  autoComplete,
  lang,
}) => {
  return (
    <div className="input-container">
      {label && (
        <label className="input-label">
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      <div className="input-wrapper">
        {startIcon && search && (
          <span className="input-icon start-icon">{startIcon}</span>
        )}
        <input
          className={`custom-input ${
            startIcon && search ? "addSearchPadding" : "addTextFieldPadding"
          }`}
          type={type}
          placeholder={placeholder}
          value={value}
          name={name}
          onChange={onChange}
          style={{
            // width: search ? "400px" : "",
            paddingLeft: search ? "40px" : "20px",
          }}
          required={required}
          onFocus={onFocus}
          onClick={onClick}
          onKeyPress={onKeyPress}
          autoComplete={autoComplete}
          lang={lang}
        />
        {endIcon && (
          <span className="input-icon end-icon" onClick={onClickEndIcon}>
            {endIcon}
          </span>
        )}
      </div>
    </div>
  );
};

export default Input;
